module.exports = __webpack_public_path__ + "static/media/cartoon_pic_fenxiang.ca1c0fe7.png";